<mat-form-field style="margin-top: 24px">
	<input
		matInput
		(keyup)="applyFilter($event.target.value)"
		placeholder="Filter"
	/>
</mat-form-field>

<table
	mat-table
	matSort
	[dataSource]="dealersTable"
	class="mat-elevation-z8"
>
	<ng-container matColumnDef="sincom">
		<th
			mat-header-cell
			*matHeaderCellDef
			mat-sort-header
		>
			{{ "dealer.dac.sicnom" | translate }}
		</th>
		<td
			mat-cell
			*matCellDef="let element"
		>
			{{ element.sincom }}
		</td>
	</ng-container>

	<ng-container matColumnDef="businessName">
		<th
			mat-header-cell
			*matHeaderCellDef
			mat-sort-header
		>
			{{ "dealer.businessName" | translate }}
		</th>
		<td
			mat-cell
			*matCellDef="let element"
		>
			{{ element.businessName }}
		</td>
	</ng-container>

	<ng-container matColumnDef="address">
		<th
			mat-header-cell
			*matHeaderCellDef
			mat-sort-header
		>
			{{ "dealer.address" | translate }}
		</th>
		<td
			mat-cell
			*matCellDef="let element"
		>
			{{ element.address }}
		</td>
	</ng-container>

	<ng-container matColumnDef="city">
		<th
			mat-header-cell
			*matHeaderCellDef
			mat-sort-header
		>
			{{ "dealer.city" | translate }}
		</th>
		<td
			mat-cell
			*matCellDef="let element"
		>
			{{ element.city }}
		</td>
	</ng-container>

	<ng-container matColumnDef="configure">
		<th
			mat-header-cell
			*matHeaderCellDef
		>
			{{ "dealer.dac.select" | translate }}
		</th>
		<td
			mat-cell
			*matCellDef="let element"
		>
			<button
				style="margin: 6px"
				mat-button
				(click)="select(element)"
			>
				<i class="fa fa-check-circle fa-2x"></i>
			</button>
		</td>
	</ng-container>

	<tr
		mat-header-row
		*matHeaderRowDef="displayedColumns"
	></tr>
	<tr
		mat-row
		*matRowDef="let row; columns: displayedColumns"
	></tr>
</table>

<mat-paginator
	[pageSizeOptions]="[5, 10, 20]"
	showFirstLastButtons
></mat-paginator>